<script setup lang="ts">
import { faArrowRight, faXmark } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
    title?: string;
    hideBack?: boolean;
}
const { title = '', hideBack } = defineProps<IProps>();

const emit = defineEmits<{
    close: [];
    back: [];
}>();
</script>

<template>
    <header class="modal-header-container mobile-only">
        <div class="action-bar">
            <mr-button
                :class="{ hide: hideBack }"
                variant="transparent"
                :icon-button="{ icon: faArrowRight, color: 'white' }"
                size="big"
                @click.stop.prevent="() => !hideBack && emit('back')"
            />
            <mr-typography size="display4" weight="700" color="white">
                {{ title }}
            </mr-typography>
            <mr-button
                variant="transparent"
                :icon-button="{ icon: faXmark, color: 'white' }"
                size="big"
                @click="() => emit('close')"
            />
        </div>
        <slot />
    </header>
</template>

<style lang="scss" scoped>
.modal-header-container {
    background: usePalette();
    .action-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 8px;
        height: 72px;
        .hide {
            visibility: hidden;
        }
    }
}
</style>
